/**
 * DPL Jade — Construction Drawing Standards
 *
 * Based on IS 962 (Indian Standard for Architectural Drawing) and
 * SP 46:2003 (Engineering Drawing Practice for Schools and Colleges).
 *
 * Line weights in mm at 1:100 scale, scaled to SVG pixels by the renderer.
 */

// ─── Line types ────────────────────────────────────────────────────────────────
export const LINE = {
  OUTLINE:    { weight: 0.7,  dash: null,          color: "#000000" }, // cut wall outline
  VISIBLE:    { weight: 0.35, dash: null,          color: "#000000" }, // visible edges below cut
  HIDDEN:     { weight: 0.18, dash: [4, 3],        color: "#444444" }, // hidden lines
  CENTERLINE: { weight: 0.18, dash: [12, 4, 2, 4], color: "#444444" }, // centre lines
  DIMENSION:  { weight: 0.18, dash: null,          color: "#000000" }, // dim lines
  GRID:       { weight: 0.18, dash: [8, 3],        color: "#aaaaaa" }, // grid lines
  SECTION_CUT:{ weight: 0.70, dash: [10, 5, 2, 5], color: "#000000" }, // section cut plane
  BREAK:      { weight: 0.35, dash: [4, 2, 1, 2],  color: "#000000" }, // break lines
};

// ─── Hatch patterns (wall section fills) ──────────────────────────────────────
export const HATCH = {
  BRICK: {
    // Diagonal cross-hatch for masonry, 45° lines at 3mm spacing
    type: "diagonal",
    spacing: 3,        // mm between hatch lines (at drawing scale)
    angle: 45,
    color: "#000000",
    opacity: 0.7,
  },
  CONCRETE: {
    // Dot pattern for concrete / RC
    type: "concrete",
    spacing: 4,
    color: "#333333",
    opacity: 0.6,
  },
  INSULATION: {
    // Zigzag for insulation / partition
    type: "zigzag",
    spacing: 4,
    color: "#555555",
    opacity: 0.5,
  },
  EARTH: {
    // Irregular diagonal for earth/ground in section
    type: "earth",
    spacing: 5,
    color: "#8B4513",
    opacity: 0.5,
  },
  VOID: {
    // Empty / air space
    type: "none",
    color: "#ffffff",
    opacity: 1,
  },
};

// Map material IDs to hatch patterns
export const MAT_HATCH = {
  BRICK:     HATCH.BRICK,
  AAC:       HATCH.CONCRETE,
  HOLLOW:    HATCH.CONCRETE,
  RC:        HATCH.CONCRETE,
  PARTITION: HATCH.INSULATION,
  GLASS:     HATCH.VOID,
};

// ─── Standard drawing scales ───────────────────────────────────────────────────
export const SCALES = [
  { label: "1:50",  value: 50  },
  { label: "1:100", value: 100 },
  { label: "1:200", value: 200 },
  { label: "1:500", value: 500 },
];

// ─── Sheet sizes in mm (landscape) ───────────────────────────────────────────
export const SHEETS = {
  A4:  { w: 297, h: 210, margin: 10, titleH: 25 },
  A3:  { w: 420, h: 297, margin: 10, titleH: 30 },
  A2:  { w: 594, h: 420, margin: 15, titleH: 35 },
  A1:  { w: 841, h: 594, margin: 20, titleH: 40 },
};

// ─── Dimension style ───────────────────────────────────────────────────────────
export const DIM_STYLE = {
  arrowSize:   2.5,   // mm
  textHeight:  2.5,   // mm
  offset:      8,     // mm from wall face to first dim line
  chainOffset: 6,     // mm between dim line chains
  extensionGap:2,     // mm gap between wall and extension line start
  extensionLen:3,     // mm overshoot past dim line
  font:        "Arial, Helvetica, sans-serif",
};

// ─── Symbol sizes (all in mm at 1:100) ────────────────────────────────────────
export const SYMBOL = {
  northArrowR: 10,    // radius of north arrow circle
  doorSwingR:  900,   // door swing radius in world mm (same as door width)
  windowSillT: 2,     // window sill line thickness in mm at scale
  stairArrowL: 15,    // stair direction arrow length in mm
};
